import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logo-student-choice-mobile.png'


const _hoisted_1 = { class: "xheader" }
const _hoisted_2 = { class: "xheader-search" }
const _hoisted_3 = {
  key: 0,
  class: "xheader-search-dropdown"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  class: "xusericon",
  "data-size": "small"
}
const _hoisted_6 = { class: "xusericon-picture" }
const _hoisted_7 = { class: "xheader-search-dropdown-result" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["data-type"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 1,
  class: "xheader-search-dropdown"
}
const _hoisted_13 = {
  key: 0,
  style: {"text-transform":"uppercase","font-size":"11px","margin-top":"20px","margin-bottom":"10px","padding-left":"15px"}
}
const _hoisted_14 = {
  class: "xusericon",
  "data-size": "small"
}
const _hoisted_15 = {
  key: 0,
  class: "xusericon-picture"
}
const _hoisted_16 = {
  key: 1,
  class: "xusericon-picture"
}
const _hoisted_17 = { class: "xheader-search-dropdown-result" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["data-type"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 0,
  class: "xheader-user"
}
const _hoisted_22 = { class: "xusericon-picture" }
const _hoisted_23 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_24 = { class: "xheader-user-name" }

import store from "@/store";
import { onMounted, reactive, computed, ref } from "vue";
import functions from "@/use/functions.js";
import useFunctions from "@/use/functions1";
import { usePermissionsStore } from "@/store/store/permissionsStore";
import type { AxiosResponse } from "axios";
import type { RecentlyViewedItem } from "@/types/search-page";
import type { BorrowerSlim } from "@/models/loans";

interface ComputedApplicationItem {
  productName: string;
  loanId: number;
  lenderId: number;
  loanAmount: number;
  referenceId: string;
  statusId: number;
  statusName: string;
  borrowers: BorrowerSlim[];
  createdAtUtc: Date;
  createdAtFormatted: string;
  name: string;
  initials: string;
  lenderName: string;
  searchCategory: string;
  searchNotification?: any;
	id?: number | string;
	borrowerInitials?: string;
	borrowerName?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { decodeHTMLEncodedStr } = useFunctions();

// TODO: Refactor to use refs
// --------------------------
// This is a global ref declaration '$ref' that needed to be used as to not force a re-factor of the entire component
// This is a temporary solution until the entire component can be re-factored to use Vue refs the correct way and all
// legacy code is removed. Using $ref and direct store state mutation usually leads to tight coupling and is not
// recommended so fully encapsulating app state in Pinia will make the app more predictable, scalable, maintain and
// way easier to test.
// --------------------------
const showTooltip = ref<boolean>(false);

const headerSearch = ref<string>("");
const headerDropdownVisble = ref<boolean>(false);
const search = reactive({
  applicationData: [],
  loanData: [],
  typing: "",
  type: "",
  text: "",
  focus: false,
});

const permissionsStore = usePermissionsStore();

const roleNames = computed(() => {
  if (permissionsStore.currentUser.roles) {
    return permissionsStore.currentUser.roles.map((role) => role.name);
  }
  return [];
});

async function searchDropdown(searchText) {
  // clean the search text
  searchText = functions.cleanSearchText(searchText);
  search.typing = searchText;

  // search the applications
  try {
    const appResponse = await functions.getApplications(searchText);
    search.applicationData = appResponse.data?.data || [];
  } catch (error) {
    search.applicationData = [];
    console.log(error);
  }

  try {
    const loanResponse = await functions.getLoans(searchText);
    search.loanData = (loanResponse as AxiosResponse).data?.items || [];
  } catch (error) {
    search.loanData = [];
    console.log(error);
  }
}
// functions
//   .getApplications(searchText)
//   .then((response) => {
//     search.applicationData = response.data.data;
//   })
//   .catch((error) => {
//     search.applicationData = [];
//     console.log(error);
//   });

// search the loans
// functions
//   .getLoans(searchText)
//   .then((response) => {
//     search.loanData = response.data.items;
//   })
//   .catch((error) => {
//     search.loanData = [];
//     console.log(error);
//   });

function toggle(key) {
  eval(`${key}.value=!${key}.value`);
}

function blurSearchbox() {
  setTimeout(() => {
    search.focus = false;
  }, 200);
}

const firstName = computed(() => {
  return decodeHTMLEncodedStr(store.state.oidcStore.user.given_name);
});

const lastName = computed(() => {
  return decodeHTMLEncodedStr(store.state.oidcStore.user.family_name);
});

const applicantInitials = computed(() => {
  return `${firstName?.value?.charAt(0)} ${lastName?.value?.charAt(0)}` || "";
});

const computedApplicationsDropdown = computed<ComputedApplicationItem[]>(() => {
  var data = [];

  if (Array.isArray(search.loanData)) {
    data = data.concat(search.loanData);
  }

  if (Array.isArray(search.applicationData)) {
    data = data.concat(search.applicationData);
  }

  return data;
});

const computedRecentlyViewed = computed<RecentlyViewedItem[]>(() => {
  // if the localstorage has any recently viewed pages
  const cachedItems = localStorage.getItem("cache.RecentlyViewedPages");

  if (cachedItems !== null) {
    // append to recentlyViewed
    const recentlyViewed = JSON.parse(cachedItems);

    if (recentlyViewed) {
      return recentlyViewed.filter((r: RecentlyViewedItem) => r.id);
    }
  }

  return [];
});

onMounted(async () => {
  await functions.getLenders();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "xheader-logo-mobile" }, [
      _createElementVNode("a", { href: "#" }, [
        _createElementVNode("img", { src: _imports_0 })
      ])
    ], -1)),
    _createElementVNode("div", {
      class: "xheader-menu-mobile",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).state.mobileMenu = !_unref(store).state.mobileMenu))
    }, [...(_cache[9] || (_cache[9] = [
      _createElementVNode("div", { class: "icon-menu" }, null, -1)
    ]))]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Search...",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.typing) = $event)),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (search.focus = true)),
        onBlur: blurSearchbox,
        onKeyup: [
          _cache[3] || (_cache[3] = ($event: any) => (searchDropdown(search.typing))),
          _cache[4] || (_cache[4] = _withKeys(($event: any) => (($event.target as HTMLInputElement).blur()), ["enter"]))
        ]
      }, null, 544), [
        [
          _vModelText,
          search.typing,
          void 0,
          { trim: true }
        ]
      ]),
      (search.typing.length >= 3 && search.focus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (computedApplicationsDropdown.value)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedApplicationsDropdown.value.slice(
              0,
              5
            ), (application, index) => {
                    return (_openBlock(), _createBlock(_component_router_link, {
                      key: index,
                      to: `/${application.searchCategory.toLowerCase()}s/${
              application.referenceId || application.id
            }`,
                      replace: ""
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, _toDisplayString(application.initials || application?.borrowerInitials || ""), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("h4", null, [
                            _createElementVNode("span", {
                              innerHTML: application.name || application?.borrowerName || 'No Name',
                              style: {"vertical-align":"middle"}
                            }, null, 8, _hoisted_8),
                            _createElementVNode("span", {
                              class: "xinfopill",
                              "data-type": application.searchCategory
                            }, _toDisplayString(application.searchCategory), 9, _hoisted_9)
                          ]),
                          (application.searchNotification)
                            ? (_openBlock(), _createElementBlock("h5", {
                                key: 0,
                                innerHTML: application.searchNotification
                              }, null, 8, _hoisted_10))
                            : (_openBlock(), _createElementBlock("h5", {
                                key: 1,
                                innerHTML: application.lenderName || 'No Lender Provided'
                              }, null, 8, _hoisted_11))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (search.typing.length < 3 && search.focus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("nav", null, [
              (computedRecentlyViewed.value.length > 0 && search.typing.length < 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Recently Viewed "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedRecentlyViewed.value.slice(0, 5), (application, index) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: index,
                  to: `/${application.page}/${application.id}`,
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      (application.firstName && application.lastName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(application.firstName?.charAt(0)) + _toDisplayString(application.lastName?.charAt(0)), 1))
                        : _createCommentVNode("", true),
                      (
                  (application.category === 'Certifications' ||
                    application.category === 'Disursements') &&
                  application.borrowerInitials
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(application.borrowerInitials), 1))
                        : _createCommentVNode("", true),
                      _cache[10] || (_cache[10] = _createElementVNode("div", {
                        class: "xusericon-gender",
                        "data-gender": ""
                      }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("h4", null, [
                        _createElementVNode("span", {
                          innerHTML: 
                    application.name || application.borrowerName || 'No Name'
                  ,
                          style: {"vertical-align":"middle"}
                        }, null, 8, _hoisted_18),
                        _createElementVNode("span", {
                          class: "xinfopill",
                          "data-type": application.category
                        }, _toDisplayString(application.category), 9, _hoisted_19)
                      ]),
                      _createElementVNode("h5", {
                        innerHTML: 
                  _unref(functions).getLenderName(
                    application.lenderId,
                    application.lenderName
                  )
                
                      }, null, 8, _hoisted_20)
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128)),
              _createElementVNode("div", {
                style: {"display":"none","text-transform":"uppercase","font-size":"11px","line-height":"36px","text-align":"center","background":"#eeeeee","cursor":"pointer"},
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (headerSearch.value = ''), ["prevent"]))
              }, " Show More ")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(store).state.oidcStore.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (toggle('headerDropdownVisble')), ["prevent"]))
          }, [
            _createElementVNode("div", {
              class: "xusericon",
              "data-size": "small",
              style: {"float":"left"},
              onMouseenter: _cache[6] || (_cache[6] = ($event: any) => (showTooltip.value = true)),
              onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (showTooltip.value = false))
            }, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(applicantInitials.value), 1),
              (showTooltip.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Your current role is: " + _toDisplayString(roleNames.value.join(", ")), 1))
                : _createCommentVNode("", true)
            ], 32),
            _createElementVNode("div", _hoisted_24, [
              _createTextVNode(_toDisplayString(firstName.value) + " " + _toDisplayString(lastName.value) + " ", 1),
              _cache[11] || (_cache[11] = _createElementVNode("i", { class: "icon-down-open-big" }, null, -1))
            ]),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "clear" }, null, -1))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["xheader-user-dropdown", { visible: headerDropdownVisble.value }])
          }, [
            _createElementVNode("nav", null, [
              _createVNode(_component_router_link, {
                to: "/profile",
                class: "icon-home",
                style: {"display":"none"}
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("Profile", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "icon-doc-text",
                style: {"display":"none"}
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("Settings", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "/logout" }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("Logout", -1)
                ]))]),
                _: 1
              })
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear" }, null, -1))
  ]))
}
}

})